<div class="card modern-card dark-pricing-modal d-flex flex-column">
  <!-- Header -->
  <div class="card-header border-0 bg-transparent pt-3 px-4">
    <div class="d-flex justify-content-between align-items-center">
      <div class="header-content">
        <h2 class="modern-header fs-4 mb-0">
          <i class="fa-solid fa-tags me-2" style="color: #00a8ff"></i>
          Competitor Pricing
        </h2>
      </div>
      <div class="header-actions">
        <button
          type="button"
          class="close-btn"
          (click)="closeModalClick()"
          title="Close"
        >
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>
  </div>

  <!-- Pricing Info Banner -->
  <div class="pricing-stats-banner px-4 py-3">
    <div class="stats-grid">
      <!-- Cheapest Card -->
      <div class="stat-card cheapest">
        <div class="stat-icon">
          <i class="fa-solid fa-award"></i>
        </div>
        <div class="stat-details">
          <span class="stat-label">Cheapest Price</span>
          <span class="stat-value">${{ cheapest_price }}</span>
          <div class="stat-margin" [ngClass]="{'negative': cheapest_price_margin < 0}">
            <i class="fa-solid" [ngClass]="cheapest_price_margin < 0 ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
            Margin: <span>{{ cheapest_price_margin !== 'N/A' ? '$' : '' }}{{ cheapest_price_margin }}</span>
          </div>
        </div>
      </div>

      <!-- Average Card -->
      <div class="stat-card average">
        <div class="stat-icon">
          <i class="fa-solid fa-chart-line"></i>
        </div>
        <div class="stat-details">
          <span class="stat-label">Average Price</span>
          <span class="stat-value">${{ average_price }}</span>
          <div class="stat-margin" [ngClass]="{'negative': average_price_margin < 0}">
            <i class="fa-solid" [ngClass]="average_price_margin < 0 ? 'fa-arrow-down' : 'fa-arrow-up'"></i>
            Margin: <span>{{ average_price_margin !== 'N/A' ? '$' : '' }}{{ average_price_margin }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Body: Grid -->
  <div class="card-body p-0 d-flex flex-column overflow-hidden" style="flex: 1">
    <div style="flex: 1; overflow: hidden; padding: 0 1rem 1rem 1rem;">
      <ag-grid-angular
        id="competitor_pricing_grid"
        class="modern-grid"
        style="width: 100%; height: 100%"
        [columnDefs]="columnDefs"
        [gridOptions]="gridOptions"
        [defaultColDef]="defaultColDef"
        [rowData]="pricing_data"
        [animateRows]="true"
        [rowSelection]="rowSelection"
        [components]="components"
        [enableBrowserTooltips]="true"
        (gridReady)="onGridReady($event)"
        (rowClicked)="onRowClicked($event)"
      ></ag-grid-angular>
    </div>
  </div>
</div>
